export enum ReferenceTypeEnum 
{
    BASKET = 1,
    COUPON = 2,
    REWARDS = 3,
    BOOSTER = 4,
    POS = 5,
    PAYMENT = 6,
}